// extracted by mini-css-extract-plugin
export default {"item-counter":"ItemCounter_item-counter__6bFDE"};